import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function WelcomeSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1]
      }
    }
  };
  return <section className="py-32 bg-weiss relative overflow-hidden" data-id="element-212">
      <div className="max-w-7xl mx-auto px-6" data-id="element-213">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-center" data-id="element-214">
          {/* Text Content */}
          <motion.div className="lg:col-span-7" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-100px'
        }} data-id="element-215">
            <motion.h2 variants={itemVariants} className="text-sm font-heading text-royal-blue uppercase tracking-widest mb-4" data-id="element-216">
              Zahnarztpraxis Nürnberg – Ihr Zahnarzt vor Ort
            </motion.h2>
            <motion.h3 variants={itemVariants} className="text-4xl md:text-5xl font-heading text-schwarz mb-8" data-id="element-217">
              Herzlich Willkommen!
            </motion.h3>

            <div className="space-y-6 text-lg text-warm-gray leading-relaxed font-body" data-id="element-218">
              <motion.p variants={itemVariants} data-id="element-219">
                Als Zahnärztinnen und Zahnärzte in Nürnberg wissen wir:
                Zahngesundheit hat viele Facetten. Bei edel & weiss vereinen wir
                all diese Gebiete für unsere Patienten und Patientinnen in einer
                Praxis. Wir heißen Sie mit einem Team aus dreizehn Zahnärzten
                und -ärztinnen im Großraum Nürnberg, Fürth und Erlangen herzlich
                willkommen und freuen uns auf Sie.
              </motion.p>
              <motion.p variants={itemVariants} data-id="element-220">
                Wir haben ein eigenes Dentallabor und verfügen über eine
                ausgezeichnete Expertise. Zahnarzt oder Zahnärztin ist nicht nur
                ein Beruf, es ist eine Berufung.
              </motion.p>
              <motion.p variants={itemVariants} data-id="element-221">
                Wir sind mehr als eine Zahnarztpraxis in Nürnberg, denn wir
                bringen die Zukunft der Zahnmedizin an einen Ort und ermöglichen
                auch gesetzlich versicherten Patienten und Patientinnen eine
                Behandlung auf hohem Niveau. Einzigartig in Deutschland vereint
                edel & weiss drei der führenden zertifizierten Spezialisten für
                Ästhetik und Funktion (DGÄZ). Weitere Fachbereiche wie die
                Kieferorthopädie, Oralchirurgie und Sportzahnmedizin schließen
                sich an und sind unter einem Dach vereint.
              </motion.p>
            </div>
          </motion.div>

          {/* Decorative Visual */}
          <motion.div className="lg:col-span-5 relative h-[600px] rounded-2xl overflow-hidden" initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          ease: 'easeOut'
        }} viewport={{
          once: true
        }} data-id="element-222">
            <div className="absolute inset-0 bg-gradient-to-tr from-royal-blue/20 to-beige/60 mix-blend-multiply" data-id="element-223" />
            <div className="absolute inset-0 bg-sand/30 backdrop-blur-[2px]" data-id="element-224" />

            {/* Abstract shapes inside placeholder */}
            <motion.div animate={{
            rotate: 360
          }} transition={{
            duration: 50,
            repeat: Infinity,
            ease: 'linear'
          }} className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 border border-royal-blue/20 rounded-full" data-id="element-225" />
            <motion.div animate={{
            rotate: -360
          }} transition={{
            duration: 40,
            repeat: Infinity,
            ease: 'linear'
          }} className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 border border-royal-blue/30 rounded-full" data-id="element-226" />
          </motion.div>
        </div>
      </div>
    </section>;
}